import translations from './resources'
const getLocalized = () => {
  const localized = translations.default
  return localized
}
export { translations }
export default getLocalized
